import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { NetworkOutageService } from 'src/app/services/network-outage.service';
import { NotificationService } from 'src/app/services/notification-service';

@Component({
  selector: 'app-network-outage-add',
  templateUrl: './network-outage-add.component.html',
  styleUrls: ['./network-outage-add.component.scss']
})
export class NetworkOutageAddComponent implements OnInit {
  form: FormGroup
  isDisableServiceProvider = false
  serviceProviderList
  filteredList1
  filteredList3
  provinceList
  id
  constructor(
    public formBuilder: FormBuilder,
    public navigation: NavigationService,
    public lookupdataservice: LookupDataServiceService,
    public activateroute: ActivatedRoute,
    public NetworkOutageService: NetworkOutageService,
    public toast: NotificationService,
  ) {
    this.activateroute.params.subscribe((params: any) => {
      this.id = parseInt(params.id)
    })
  }

  toolbarModules = {
    toolbar: [
      ['bold', 'italic'],
      [{ 'color': [] }],
      ['underline', 'strike'],
      ['code-block', 'blockquote'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      ['link'],
      [{ 'align': [] }]
    ]
  };
  ngOnInit(): void {
    this.initform()
    this.getdata()
  }
  initform() {
    this.form = this.formBuilder.group({
      serviceProviderId: [null, Validators.required],
      provinces: [null, Validators.required],
      city: [null, Validators.required],
      description: [null, Validators.required],
      subject: [null, Validators.required],
      outageStatus: [1, Validators.required],
    })
  }
  getdata() {
    this.lookupdataservice.getServiceProvider().subscribe((result) => {
      this.serviceProviderList = result
      this.filteredList1 = [...this.serviceProviderList]
    })
    this.lookupdataservice.getProvince().subscribe((result) => {
      this.provinceList = result
      this.filteredList3 = [...this.provinceList]
    })
    if (this.id != 0) {
      let payload = { OutageId: this.id }
      this.NetworkOutageService.GetNetworkOutageById(payload).subscribe((result) => {
        this.form.patchValue(result)
        this.form.disable()
        this.form.get('subject').enable()
        this.form.get('description').enable()

      })

    }
  }
  save() {
    if (this.form.valid) {
      let payload = this.form.getRawValue()
      
      if (payload.outageStatus == null || payload.outageStatus != 0)
        payload.outageStatus = 1
      if(this.id!=0)
        payload.id=this.id
      this.NetworkOutageService.SaveNetworkOutageDetails(payload).subscribe((result) => {
        if (result)
          this.toast.showSuccess('Saved Succesfully')
        this.goToBack()
      })
    }
  }

  reset() {
    this.form.reset()
  }
  goToBack() {
    this.navigation.goTonetworkoutage()
  }
}
